var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.28521 6.64001C6.80721 7.72723 7.5188 8.74621 8.41998 9.64739C9.32116 10.5486 10.3401 11.2602 11.4274 11.7822C11.5209 11.8271 11.5676 11.8495 11.6268 11.8668C11.8371 11.9281 12.0953 11.884 12.2733 11.7565C12.3234 11.7206 12.3663 11.6778 12.452 11.592C12.7143 11.3298 12.8454 11.1987 12.9772 11.113C13.4744 10.7898 14.1153 10.7898 14.6125 11.113C14.7443 11.1987 14.8754 11.3298 15.1376 11.592L15.2837 11.7382C15.6823 12.1368 15.8816 12.3361 15.9899 12.5501C16.2052 12.9758 16.2052 13.4785 15.9899 13.9041C15.8816 14.1182 15.6823 14.3175 15.2837 14.716L15.1655 14.8343C14.7683 15.2315 14.5697 15.4301 14.2997 15.5818C14 15.7501 13.5347 15.8711 13.191 15.8701C12.8813 15.8692 12.6696 15.8091 12.2463 15.6889C9.97125 15.0432 7.82448 13.8249 6.03349 12.0339C4.24251 10.2429 3.02415 8.09612 2.37843 5.82108C2.25827 5.39774 2.19819 5.18607 2.19727 4.87636C2.19625 4.5327 2.31727 4.06733 2.48559 3.7677C2.63727 3.49768 2.83588 3.29907 3.2331 2.90185L3.35132 2.78362C3.74991 2.38504 3.9492 2.18575 4.16323 2.07749C4.5889 1.86219 5.0916 1.86219 5.51727 2.07749C5.73131 2.18575 5.9306 2.38504 6.32918 2.78362L6.47533 2.92978C6.73754 3.19198 6.86864 3.32308 6.95435 3.45492C7.2776 3.95208 7.2776 4.59302 6.95435 5.09019C6.86864 5.22202 6.73754 5.35312 6.47533 5.61533C6.3896 5.70106 6.34673 5.74393 6.31085 5.79404C6.18334 5.97211 6.13932 6.2303 6.20061 6.44057C6.21786 6.49974 6.24031 6.5465 6.28521 6.64001Z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5a58fbf8857918d0ebb4b41a689bb274.svg";
export { ForwardRef as ReactComponent };